export interface IVersionResponse {
  version: string;
  lastModifiedDate: string;
}

export enum HealthCheckStatus {
  ERROR = "ERROR",
  WARN = "WARN",
  OK = "OK"
}

export type NodeData = { title: string; description: string; status: NodeStatus };

export enum NodeStatus {
  Unknown,
  Running,
  Success,
  Warning,
  Error
}

export interface IHealthCheckModel {
  name: string;
  success: HealthCheckStatus;
  feedback: string;
  errorType: string;
  params: { [key: string]: string };
}
